/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { cva } from "@panda/css";

export const button = cva({
	base: {
		whiteSpace: "nowrap",
		alignItems: "center",
		cursor: "pointer",
		display: "inline-flex",
		justifyContent: "center",
		maxWidth: "fit-content",
		flexShrink: "0",
		outline: "token(spacing.eds.dimension.2) solid transparent",
		textAlign: "center",
		textStyle: "buttonMD",
		transitionDuration: "token(animations.eds.duration.100)",
		transitionProperty: "background-color, border-color, color, outline-color",
		transitionTimingFunction: "token(animations.eds.easing.linear)",

		"&:focus-visible": {
			outlineColor: "token(colors.eds.border.focus)",
			outlineOffset: "eds.dimension.2",
		},
	},
	variants: {
		visual: {
			primary: {
				bg: "eds.fill.primary.default",
				color: "eds.background.default",
				_hover: { bg: "eds.fill.primary.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					background: "eds.fill.primary.disabled",
					_hover: { bg: "eds.fill.primary.disabled" },
				},
			},
			secondary: {
				bg: "eds.fill.secondary.default",
				backdropFilter: "var(--effect-material-blur, blur(50px))",
				_safari18: {
					backdropFilter: "none",
					bg: "#343437",
					_hover: { bg: "#636366" },
				},
				color: "eds.text.contrast",
				_hover: { bg: "eds.fill.secondary.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					background: "eds.fill.secondary.default",
					_hover: { bg: "eds.fill.secondary.default" },
				},
			},
			outline: {
				color: "eds.text.contrast",
				borderColor: "eds.border.default",
				borderStyle: "solid",
				borderWidth: "1px",
				_hover: { bg: "eds.background.elevated.high.hover", borderColor: "eds.border.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					background: "eds.fill.secondary.default",
					_hover: { bg: "transparent" },
				},
			},
			ghost: {
				color: "eds.text.contrast",
				bg: "transparent",
				_hover: { bg: "eds.background.elevated.high.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					_hover: { bg: "transparent" },
				},
			},
			ghostUnderline: {
				color: "eds.text.contrast",
				textDecoration: "underline",
				textUnderlinePosition: "from-font",
				bg: "transparent",
				_hover: { bg: "eds.background.elevated.high.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					_hover: { bg: "transparent" },
				},
			},
			critical: {
				bg: "eds.fill.critical.default",
				color: "eds.background.default",
				_hover: { bg: "eds.fill.critical.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					_hover: { bg: "eds.fill.critical.default" },
				},
			},
			contrast: {
				bg: "eds.fill.contrast.default",
				color: "eds.background.default",
				_hover: { bg: "eds.fill.contrast.hover" },
				_disabled: {
					cursor: "default",
					color: "eds.text.disabled.default",
					_hover: { bg: "eds.fill.contrast.default" },
				},
			},
		},
		size: {
			sm: { paddingInline: "0.5rem", paddingBlock: "0.125rem", borderRadius: "4px", minHeight: "1.5rem" },
			md: { paddingInline: "0.75rem", paddingBlock: "0.25rem", borderRadius: "6px", minHeight: "2rem" },
			lg: { paddingInline: "1rem", paddingBlock: "0.5rem", borderRadius: "0.5rem", minHeight: "2.5rem" },
			xl: {
				paddingInline: "1.25rem",
				paddingBlock: "0.75rem",
				borderRadius: "10px",
				minHeight: "3rem",
				smDown: { paddingInline: "1rem", paddingBlock: "0.5rem", borderRadius: "0.5rem", minHeight: "2.5rem" },
			},
		},
	},
});
